/**
 * Node modules
 */
import PropTypes from 'prop-types';
import Radio from 'antd/lib/radio';
import React from 'react';

/**
 * Functional components
 */
const VendorAntGroupRadio = (props) => {
  const {
    isDisabled,
    ...rest
  } = props;
  return (
    <Radio.Group
      disabled={isDisabled}
      {...rest}
    />
  );
};
VendorAntGroupRadio.defaultProps = { isDisabled: false };
VendorAntGroupRadio.displayName = 'VendorAntGroupRadio';
VendorAntGroupRadio.propTypes = { isDisabled: PropTypes.bool };
export default VendorAntGroupRadio;
